import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class MenuService {
    private menuItemLoginDisplayStatus: string = 'none';
    private menuItemLogoutDisplayStatus: string = 'none';
    private menuItemHelpDisplayStatus: string = 'none';
    private menuItemProfileDisplayStatus: string = 'none';
    private menuItemRolesDisplayStatus: string = 'none';
    private menuItemServicesDisplayStatus: string = 'none';
    private menuItemAdminDisplayStatus: string = 'none';

    setDisplayStatusByMenuType(menuType: string) {
      if (menuType === 'login') {
        this.menuItemLoginDisplayStatus = 'none';
        this.menuItemLogoutDisplayStatus = 'none';
        this.menuItemHelpDisplayStatus = 'block';
        this.menuItemProfileDisplayStatus = 'none';
        this.menuItemRolesDisplayStatus = 'none';
        this.menuItemServicesDisplayStatus = 'none';
        this.menuItemAdminDisplayStatus = 'none';
      } else if (menuType === 'public') {
        this.menuItemLoginDisplayStatus = 'block';
        this.menuItemLogoutDisplayStatus = 'none';
        this.menuItemHelpDisplayStatus = 'block';
        this.menuItemProfileDisplayStatus = 'none';
        this.menuItemRolesDisplayStatus = 'none';
        this.menuItemServicesDisplayStatus = 'none';
        this.menuItemAdminDisplayStatus = 'none';
      } else if (menuType === 'secure') {  
        this.menuItemLoginDisplayStatus = 'none';
        this.menuItemLogoutDisplayStatus = 'block';
        this.menuItemHelpDisplayStatus = 'block';
        this.menuItemProfileDisplayStatus = 'block';
        this.menuItemRolesDisplayStatus = 'block';
        this.menuItemServicesDisplayStatus = 'block';
        this.menuItemAdminDisplayStatus = 'none';
      } else if (menuType === 'admin') {  
        this.menuItemLoginDisplayStatus = 'none';
        this.menuItemLogoutDisplayStatus = 'block';
        this.menuItemHelpDisplayStatus = 'block';
        this.menuItemProfileDisplayStatus = 'block';
        this.menuItemRolesDisplayStatus = 'block';
        this.menuItemServicesDisplayStatus = 'block';
        this.menuItemAdminDisplayStatus = 'block';
      } else if (menuType === 'noauth') {  
        this.menuItemLoginDisplayStatus = 'none';
        this.menuItemLogoutDisplayStatus = 'block';
        this.menuItemHelpDisplayStatus = 'block';
        this.menuItemProfileDisplayStatus = 'none';
        this.menuItemRolesDisplayStatus = 'none';
        this.menuItemServicesDisplayStatus = 'none';
        this.menuItemAdminDisplayStatus = 'none';
      } else {
        this.menuItemLoginDisplayStatus = 'none';
        this.menuItemLogoutDisplayStatus = 'none';
        this.menuItemHelpDisplayStatus = 'none';
        this.menuItemProfileDisplayStatus = 'none';
        this.menuItemRolesDisplayStatus = 'none';
        this.menuItemServicesDisplayStatus = 'none';
        this.menuItemAdminDisplayStatus = 'none';
      }  
    }

    getMenuItemLoginDisplayStatus() {
      return this.menuItemLoginDisplayStatus;
    }

    getMenuItemLogoutDisplayStatus() {
      return this.menuItemLogoutDisplayStatus;
    }

    getMenuItemHelpDisplayStatus() {
      return this.menuItemHelpDisplayStatus;
    }

    getMenuItemProfileDisplayStatus() {
      return this.menuItemProfileDisplayStatus;
    }

    getMenuItemRolesDisplayStatus() {
      return this.menuItemRolesDisplayStatus;
    }

    getMenuItemServicesDisplayStatus() {
      return this.menuItemServicesDisplayStatus;
    }

    getMenuItemAdminDisplayStatus() {
      return this.menuItemAdminDisplayStatus;
    }    

    redirectAdminLink() {
      window.location.href = "/opsbpssecure/secure/paadmin/role/search?ts=" + Date.now();
      return null;
    }
}